import styled from 'styled-components';
import RangeInput from 'js/components/core/form/RangeInput';

export default styled(RangeInput)`
  margin: 0 0.5rem;
  width: 2rem;

  &:first-child {
    margin-left: 0;
  }
  &:last-child {
    margin-right: 0;
  }
`;
